<template>
  <div class="p-4">ClientVentasPedidos</div>
</template>

<script>
export default {
  name: 'ClientVentasPedidos'
}
</script>
